<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      optionLevelKompetensi: [],
      form: {
        id_jenjang_jabatan: null,
        idlevel_kompetensi: null,
        nama_jenjang: "",
        deskripsi: "",
        jumlah_peg: "",
        jumlah_kompetensi: "",
        nilai_awal: "",
        nilai_akhir: "",
        nilai_teks: "",
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          this.form = {
            id_jenjang_jabatan: this.data.id_jenjang_jabatan,
            nama_jenjang: this.data.nama_jenjang ?? "",
            deskripsi: this.data.deskripsi ?? "",
          };
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {

    resetForm() {
      this.form = {
        id_jenjang_jabatan: null,
        nama_jenjang: "",
        deskripsi: "",
      };
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.nama_jenjang) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Jenjang Jabatan tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION +
            "master-asesmen/jenjang-jabatan/" +
            this.form.id_jenjang_jabatan
          : this.BACKEND_URL_VERSION + "master-asesmen/jenjang-jabatan";

      const method = this.mode === "edit" ? "put" : "post";

      this.isLoading = true;
      axios({
        method,
        url,
        data: this.form,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Jenjang Jabatan' : 'Tambah Jenjang Jabatan'"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="Jenjang Jabatan" class="fw-medium">
        <b-form-input
          v-model="form.nama_jenjang"
          placeholder="Masukkan Jenjang Jabatan"
        ></b-form-input>
      </b-form-group>

    <div class="mb-3">
        <label for="deskripsi" class="form-label">Deskripsi</label>
        <textarea
          v-model="form.deskripsi"
          class="form-control"
          id="deskripsi"
          required
        ></textarea>
      </div>
     
      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>